<div class="sci-pill" *ngIf="visible" role="status" aria-live="polite">
  <i class="pi pi-wifi sci-icon"></i>
  <span class="sci-text">{{ 'common.slowConnection' | t }}</span>
  <button type="button" class="sci-dismiss" (click)="dismiss()" [attr.aria-label]="'common.dismiss' | t">
    <i class="pi pi-times"></i>
  </button>
</div>
